export default __webpack_public_path__ + "static/media/VAS Provider.efe7782c.jpg";